(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-review-carousel"] && !Shopify.designMode) return;
  try {
    
function initializeReviews(scope) {
  scope.querySelectorAll('.reviews-carousel .read-more-review').forEach(button => {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      const text = document.getElementById(button.getAttribute('aria-controls'));
      if (!text) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      text.classList.toggle('expanded', expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
    });
  });
}
initializeReviews(document);
document.addEventListener('shopify:section:load', event => initializeReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-cream-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nc-header details').forEach(function(detail) {
  detail.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      detail.open = false;
      detail.querySelector('summary').focus();
    }
  });
  detail.addEventListener('toggle', function() {
    if (detail.open) document.querySelectorAll('.nc-header details').forEach(function(other) { if (other !== detail) other.open = false; });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-cream-home"] && !Shopify.designMode) return;
  try {
    
function initNestfulgoldReviews(scope) {
  scope.querySelectorAll('[data-review-carousel]').forEach(function(carousel) {
    if (carousel.dataset.initialized) return;
    var cards = Array.from(carousel.querySelectorAll('.nc-review'));
    var controls = carousel.querySelector('[data-review-controls]');
    if (!controls || cards.length <= 3) return;
    carousel.dataset.initialized = 'true';
    var page = 0;
    var pages = Math.ceil(cards.length / 3);
    var status = carousel.querySelector('[data-review-status]');
    function showPage(nextPage) {
      page = (nextPage + pages) % pages;
      cards.forEach(function(card, index) { card.hidden = index < page * 3 || index >= (page + 1) * 3; });
      status.textContent = carousel.dataset.pageFormat.replace('__CURRENT__', page + 1).replace('__TOTAL__', pages);
    }
    carousel.querySelector('[data-review-prev]').addEventListener('click', function() { showPage(page - 1); });
    carousel.querySelector('[data-review-next]').addEventListener('click', function() { showPage(page + 1); });
    controls.hidden = false;
    showPage(0);
  });
}
initNestfulgoldReviews(document);
document.addEventListener('shopify:section:load', function(event) { initNestfulgoldReviews(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-fvm-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nfp-demo-player')) {
  customElements.define('nfp-demo-player', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const video = this.querySelector('video');
      const button = this.querySelector('[data-video-play]');
      const status = this.querySelector('[data-video-status]');
      if (!video || !button || !status) return;
      let requested = false;
      let triedFallback = false;
      const showStatus = (text) => { status.textContent = text; status.hidden = !text; };
      const update = () => {
        button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-label', button.textContent + ': ' + document.getElementById(video.getAttribute('aria-labelledby'))?.textContent.trim());
      };
      const play = () => {
        requested = true;
        showStatus(status.dataset.loading);
        const attempt = video.play();
        attempt?.catch(() => { showStatus(status.dataset.error); update(); });
      };
      button.hidden = false;
      button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); }, options);
      video.addEventListener('play', () => {
        requested = true;
        this.closest('.nfp-video-grid')?.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
        update();
      }, options);
      video.addEventListener('playing', () => showStatus(''), options);
      video.addEventListener('waiting', () => { if (requested) showStatus(status.dataset.loading); }, options);
      video.addEventListener('pause', () => { showStatus(''); update(); }, options);
      video.addEventListener('ended', update, options);
      video.addEventListener('error', () => {
        const fallback = this.querySelector('source[type="video/mp4"]');
        if (!triedFallback && fallback && video.currentSrc !== fallback.src) {
          triedFallback = true;
          video.src = fallback.src;
          video.load();
          if (requested) play();
        } else showStatus(status.dataset.error);
      }, options);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelector('video')?.pause();
    }
  });
}

if (!customElements.get('nfp-sign-choice')) {
  customElements.define('nfp-sign-choice', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const select = this.querySelector('select');
      const fields = this.querySelector('[data-sign-fields]');
      const input = fields.querySelector('input');
      const sync = () => {
        const required = Boolean(select.selectedOptions[0]?.hasAttribute('data-custom-sign'));
        fields.hidden = !required;
        input.disabled = !required;
        input.required = required;
      };
      select.addEventListener('change', sync, { signal: this.controller.signal });
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
